import React from 'react';
import { Grid, TableBody, TableCell, TableHead, TableRow, withStyles } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import axiosInstance, { WEB_API, EVENT_ID, setScrollPosition } from '../constatns';
// import UploadToS3 from '../common/UploadToS3';
import SubTitle from '../components/Text/SubTitle';
import Table from '../components/Table/Table';
import ConfirmButton from '../components/Button/ConfirmButton';

import moment from 'moment';
import swal from '@sweetalert/with-react';
import { paperAction } from './FreePaperAction';

const styles = (theme) => ({
  tableBody: {
    '& th': {
      width: '20%',
    },
  },

  notBold: {
    '& th': {
      fontWeight: 500,
    },
    '& td': {
      fontWeight: 500,
    },
  },

  alignLeft: {
    '& th': {
      textAlign: 'left !important',
    },
    '& td': {
      textAlign: 'left !important',
    },
  },
  alignCenter: {
    '& th': {
      textAlign: 'center !important',
    },
    '& td': {
      textAlign: 'center !important',
    },
  },

  figuresLink: {
    cursor: 'pointer',
    textDecorationLine: 'underline',
    textDecorationColor: 'blue',
    color: 'blue',
  },
});

class FreePaperSubmissionConfirm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
      data: this.props.infoData || this.props.data,
      paperId: this.props.abstractId,
      avg: 0,
      total: 0,
      isSubmitting: false,
    };
  }

  componentDidMount() {
    setScrollPosition(0);
    if (this.props.infoData) {
      let total = 0;
      this.props.infoData.reviewResult &&
        //eslint-disable-next-line
        this.props.infoData.reviewResult.map((res, idx) => {
          total += res.totalScore;
        });
      const avg = this.props.infoData.reviewResult ? total / this.props.infoData.reviewResult.length : 0;
      this.setState({ total: total, avg: avg });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.data && nextProps.data.id) {
      return { paperId: nextProps.data.id, data: nextProps.data };
    }
  }

  renderInstitutionList() {
    const { classes } = this.props;
    const { data } = this.state;
    if (data.numOfInstitution && data.numOfInstitution.length > 0) {
      return (
        <Table>
          {data.numOfInstitution.map((item, idx) => (
            <React.Fragment key={`institution-item-${idx}`}>
              <TableHead className={`${classes.notBold} ${classes.alignLeft}`}>
                <TableRow>
                  <TableCell colSpan={4}>Institution #{idx + 1}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className={classes.tableBody}>
                <TableRow>
                  <TableCell component={'th'}>
                    <span>*</span> Country
                  </TableCell>
                  <TableCell style={{ width: '30%' }}>{item.country && item.country}</TableCell>
                  <TableCell component={'th'}>
                    <span>*</span> Department
                  </TableCell>
                  <TableCell style={{ width: '30%' }}>{item.department && item.department}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component={'th'}>
                    <span>*</span> Affiliation
                  </TableCell>
                  <TableCell style={{ width: '30%' }}>{item.affiliation && item.affiliation}</TableCell>
                  <TableCell component={'th'}>
                    <span>*</span> City/State
                  </TableCell>
                  <TableCell style={{ width: '30%' }}>{item.city && item.city}</TableCell>
                </TableRow>
              </TableBody>
            </React.Fragment>
          ))}
        </Table>
      );
    }
  }

  renderAuthorList() {
    const { data } = this.state;

    if (data.numOfAuthor && data.numOfAuthor.length > 0) {
      return data.numOfAuthor.map((author, idx) => (
        <TableRow key={`author-item-${idx}`}>
          <TableCell>{idx + 1}</TableCell>
          <TableCell>{author.firstName && author.firstName}</TableCell>
          <TableCell>{author.lastName && author.lastName}</TableCell>
          <TableCell>
            {author.ino1 && author.ino1.split('-')[2]}
            {author.ino2 && author.ino2 !== '' ? ', ' + author.ino2.split('-')[2] : ''}
          </TableCell>
          <TableCell>{author.id && data.selectPresentingAuthor && author.id === data.selectPresentingAuthor ? 'Y' : ''}</TableCell>
          <TableCell>{author.id && data.selectCorrespondingAuthor && author.id === data.selectCorrespondingAuthor ? 'Y' : ''}</TableCell>
        </TableRow>
      ));
    }
  }

  renderAuthorInfo(type) {
    const { data } = this.state;

    for (let i = 0; i < data.numOfAuthor.length; i++) {
      if (data.numOfAuthor[i].id === data[`select${type}Author`]) {
        return (
          <React.Fragment key={`${type}-author-${i}`}>
            <TableRow>
              <TableCell component={'th'}>
                <span>*</span> Name
              </TableCell>
              <TableCell>
                {data.numOfAuthor[i].firstName && data.numOfAuthor[i].firstName}{' '}
                {data.numOfAuthor[i].lastName && data.numOfAuthor[i].lastName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>
                <span>*</span> Institution No.
              </TableCell>
              <TableCell>
                {data.numOfAuthor[i].ino1 && data.numOfAuthor[i].ino1.split('-')[2]}{' '}
                {data.numOfAuthor[i].ino2 && data.numOfAuthor[i].ino2 !== '' ? ', ' + data.numOfAuthor[i].ino2.split('-')[2] : ''}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>
                <span>*</span> Country
              </TableCell>
              <TableCell>{data.numOfAuthor[i].country && data.numOfAuthor[i].country}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>
                <span>*</span> Category
              </TableCell>
              <TableCell>{data.numOfAuthor[i].category && data.numOfAuthor[i].category}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>
                <span>*</span> Email
              </TableCell>
              <TableCell>{data.numOfAuthor[i].email && data.numOfAuthor[i].email}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>
                <span>*</span> Mobile
              </TableCell>
              <TableCell>
                {data.numOfAuthor[i].countryCode && data.numOfAuthor[i].countryCode !== '' ? '+' + data.numOfAuthor[i].countryCode : ''}
                {data.numOfAuthor[i].phoneNumber && data.numOfAuthor[i].phoneNumber !== '' ? '-' + data.numOfAuthor[i].phoneNumber : ''}
              </TableCell>
            </TableRow>
          </React.Fragment>
        );
      }
    }
  }

  renderFigures(data) {
    const { classes } = this.props;
    // console.log(data);
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>
              Figures Upload <span style={{ color: 'inherit', fontWeight: 500 }}>(format : jpg, png, gif)</span>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody className={classes.tableBody}>
          <TableRow>
            <TableCell component={'th'}>Figure 1</TableCell>
            <TableCell>
              <Grid container direction="column">
                <Grid item onClick={() => this.figurePreview(data.figures1)} className={classes.figuresLink}>
                  {data.figures1 && data.figures1.name}
                </Grid>
                <Grid item>{data.figuresMemo1 && data.figuresMemo1}</Grid>
              </Grid>
            </TableCell>
          </TableRow>
          {data.figures2 && (
            <TableRow>
              <TableCell component={'th'}>Figure 2</TableCell>
              <TableCell>
                <Grid container direction="column">
                  <Grid item onClick={() => this.figurePreview(data.figures2)} className={classes.figuresLink}>
                    {data.figures2 && data.figures2.name}
                  </Grid>
                  <Grid item>{data.figuresMemo2 && data.figuresMemo2}</Grid>
                </Grid>
              </TableCell>
            </TableRow>
          )}
          {data.figures3 && (
            <TableRow>
              <TableCell component={'th'}>Figure 3</TableCell>
              <TableCell>
                <Grid container direction="column">
                  <Grid item onClick={() => this.figurePreview(data.figures3)} className={classes.figuresLink}>
                    {data.figures3 && data.figures3.name}
                  </Grid>
                  <Grid item>{data.figuresMemo3 && data.figuresMemo3}</Grid>
                </Grid>
              </TableCell>
            </TableRow>
          )}
          {data.figures4 && (
            <TableRow>
              <TableCell component={'th'}>Figure 4</TableCell>
              <TableCell>
                <Grid container direction="column">
                  <Grid item onClick={() => this.figurePreview(data.figures4)} className={classes.figuresLink}>
                    {data.figures4 && data.figures4.name}
                  </Grid>
                  <Grid item>{data.figuresMemo4 && data.figuresMemo4}</Grid>
                </Grid>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    );
  }

  figurePreview(data) {
    //eslint-disable-next-line
    let newWin = window.open(`${data.path}`, '_blank');
  }

  onSubmit() {
    this.setState({ isSubmitting: true });

    if (!this.state.data.figures) {
      let buff = this.state.data;
      buff['figures'] = ['', '', '', ''];
      this.setState({
        data: buff,
      });
    }

    paperAction(this.state.data, 'modify', this.state.data.id, true).then((result) => {
      axiosInstance.post(`${WEB_API}/paper/paperSubmitEmail?evt=${EVENT_ID}&paperId=${this.state.data.id}`).then(() => {});
      swal('Your submission is registered successfully.', {
        icon: 'success',
      })
        .then(() => {
          if (this.props.isRegister) {
            this.props.movePage('/paper/guide');
          } else {
            this.props.handleClose();
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.setState({ isSubmitting: false });
        });
    });
  }

  render() {
    const { classes, theme, mode, isMypage } = this.props;
    const { data } = this.state;

    const spacing = () => {
      if (!this.props.isPop) {
        return (
          <Grid item xs={8}>
            <div style={{ height: '20px' }} />
          </Grid>
        );
      }
    };
    // console.log(data.methodsContent)
    return (
      <>
        <div style={{ width: '100%' }}>
          <Grid
            container
            justifyContent="center"
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0 }
            }
          >
            <Grid item xs={mode && mode === 'review' ? 12 : 8}>
              <SubTitle>Abstract Submission Status</SubTitle>
              <Table>
                <TableBody className={classes.tableBody}>
                  <TableRow>
                    <TableCell component={'th'}>
                      <span>*</span> Presentation Type
                    </TableCell>
                    <TableCell>{data.presentationType && data.presentationType}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>
                      <span>*</span> Abstract Topic
                    </TableCell>
                    <TableCell>{data.abstractTopic && data.abstractTopic}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>
                      <span>*</span> Abstract Title
                    </TableCell>
                    <TableCell>{data.abstractTitle && data.abstractTitle}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
            {spacing()}
            <Grid item xs={mode && mode === 'review' ? 12 : 8}>
              <SubTitle>Author Information</SubTitle>
              {this.renderInstitutionList()}
            </Grid>
            {spacing()}
            <Grid item xs={mode && mode === 'review' ? 12 : 8}>
              <SubTitle>Author Order (Total : {data.numOfAuthor && data.numOfAuthor.length})</SubTitle>
              <Table>
                <TableHead className={classes.notBold}>
                  <TableRow>
                    <TableCell style={{ width: '8%' }}>Order</TableCell>
                    <TableCell style={{ width: '22%' }}>
                      <span>*</span> First Name
                    </TableCell>
                    <TableCell style={{ width: '22%' }}>
                      <span>*</span> Last Name
                    </TableCell>
                    <TableCell style={{ width: '18%' }}>
                      <span>*</span> Institution No.
                    </TableCell>
                    <TableCell style={{ width: '15%' }}>
                      <span>*</span> Presenting Author
                    </TableCell>
                    <TableCell style={{ width: '15%' }}>
                      <span>*</span> Corresponding Author
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className={classes.alignCenter}>{this.renderAuthorList()}</TableBody>
              </Table>
              <div style={{ height: '10px' }} />
              <Table>
                <TableHead className={`${classes.notBold} ${classes.alignLeft}`}>
                  <TableRow>
                    <TableCell colSpan={2}>Presenting Author Information</TableCell>
                  </TableRow>
                </TableHead>
                {data.numOfAuthor && data.numOfAuthor.length > 0 && (
                  <TableBody className={classes.tableBody}>{this.renderAuthorInfo('Presenting')}</TableBody>
                )}

                <TableHead className={`${classes.notBold} ${classes.alignLeft}`}>
                  <TableRow>
                    <TableCell colSpan={2}>Corresponding Author Information</TableCell>
                  </TableRow>
                </TableHead>
                {data.numOfAuthor && data.numOfAuthor.length > 0 && (
                  <TableBody className={classes.tableBody}>{this.renderAuthorInfo('Corresponding')}</TableBody>
                )}
              </Table>
            </Grid>
            {spacing()}
            <Grid item xs={mode && mode === 'review' ? 12 : 8}>
              <SubTitle>Author Information</SubTitle>
              <Table>
                <TableBody className={classes.tableBody}>
                  <TableRow>
                    <TableCell component={'th'}>
                      <span>*</span> Purpose
                    </TableCell>
                    <TableCell>
                      {data.purposeContent && (
                        <div dangerouslySetInnerHTML={{ __html: '<div style="display: inline;">' + data.purposeContent + '</div>' }} />
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>
                      <span>*</span> Methods
                    </TableCell>
                    <TableCell>
                      {data.methodsContent && (
                        <div dangerouslySetInnerHTML={{ __html: '<div style="display: inline;">' + data.methodsContent + '</div>' }} />
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>
                      <span>*</span> Results
                    </TableCell>
                    <TableCell>
                      {data.resultsContent && (
                        <div dangerouslySetInnerHTML={{ __html: '<div style="display: inline;">' + data.resultsContent + '</div>' }} />
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>
                      <span>*</span> Conclusion
                    </TableCell>
                    <TableCell>
                      {data.conclusionContent && (
                        <div dangerouslySetInnerHTML={{ __html: '<div style="display: inline;">' + data.conclusionContent + '</div>' }} />
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
            {spacing()}
            <Grid item xs={mode && mode === 'review' ? 12 : 8}>
              {this.renderFigures(data)}
            </Grid>
            {spacing()}
            <Grid item xs={mode && mode === 'review' ? 12 : 8}>
              <Table>
                <TableBody className={classes.notBold}>
                  <TableRow>
                    <TableCell component={'th'} style={{ width: '80%' }}>
                      <span>*</span> Do you agree on changing your presentation type between oral presentation and E-Poster after
                      acceptance?
                    </TableCell>
                    <TableCell>{data.isAgree1 && data.isAgree1 === 'agree' ? 'Yes' : 'No'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'} style={{ width: '80%' }}>
                      <span>*</span> Copyright Agreement
                    </TableCell>
                    <TableCell>{data.isAgree2 && data.isAgree2 === 'agree' ? 'I agree' : `I don't agree`}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
            {this.props.isAdminReview && (
              <Grid item xs={mode && mode === 'review' ? 12 : 8} style={{ padding: theme.spacing(4, 0) }}>
                <Table>
                  <TableBody className={classes.tableBody}>
                    {this.state.data.judge.map((jd, idx) => {
                      const result = this.state.data.reviewResult ? this.state.data.reviewResult.find((r) => r.reviewer === jd.id) : null;
                      let score = '';
                      if (result) {
                        score = `${result.researchScore},${result.originalityScore},${result.concreteScore},${result.practicalityScore},${result.contributionScore}`;
                      }
                      return (
                        <TableRow key={'rv-' + idx}>
                          <TableCell component={'th'}>Review{idx + 1} View</TableCell>
                          <TableCell>
                            Name: {jd.username === jd.in_name_en ? jd.in_name_en : jd.in_name_en + ' (' + jd.username + ')'}
                            <br /> Score: {result ? result.totalScore + ' (' + score + ')' : ''}
                            <br /> Comments: {result ? result.comment : ''}
                            <br /> Date: {result ? moment(result.reviewDate).format('YYYY-MM-DD') : ''}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    <TableRow>
                      <TableCell component={'th'}>Average</TableCell>
                      <TableCell>{this.state.avg}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
            )}
            <Grid item xs={mode && mode === 'review' ? 12 : 8} style={{ padding: theme.spacing(4, 0) }}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                {!this.props.isPop && !isMypage && (
                  <ConfirmButton
                    color="secondary"
                    onClick={() => {
                      if (mode && mode === 'review') {
                        this.props.handleMode();
                      } else {
                        this.props.handleState('paperId', this.state.paperId);
                        this.props.handleState('formState', 'modify');
                      }
                    }}
                  >
                    Modify
                  </ConfirmButton>
                )}
                {/* {!this.props.isPop && ((mode && mode === 'confirm') || this.state.data.status !== 'Complete') && (
                  <>
                    <div style={{ width: '20px' }} />
                    <ConfirmButton
                      color="secondary"
                      onClick={() => {
                        this.onSubmit();
                      }}
                    >
                      Submit
                    </ConfirmButton>
                  </>
                )} */}
                <div style={{ width: '20px' }} />
                <ConfirmButton
                  onClick={() => {
                    if (mode && mode === 'review') {
                      this.props.handleClose();
                    } else {
                      this.props.movePage('/paper/guide');
                    }
                  }}
                  style={{
                    fontSize: '1.2em',
                    color: '#fff',
                    backgroundColor: '#237a9d',
                  }}
                >
                  {isMypage ? 'Confirm' : 'Cancel'}
                </ConfirmButton>
              </div>
            </Grid>
          </Grid>
        </div>
        {this.state.isSubmitting && (
          <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
            <CircularProgress size={100} thickness={5} style={{ color: theme.palette.secondary.point }} />
          </div>
        )}
      </>
    );
  }
}
export default withStyles(styles, { withTheme: true })(FreePaperSubmissionConfirm);
